// generated from 1_401 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const appVersionByAppFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("app_version_by_app_filter"),
  comparison_key: z.enum([
    "1", // 641 (45.75%)
    "10", // 307 (21.91%)
    "17", // 269 (19.20%)
    "2", // 184 (13.13%)
  ]),
  display_name: z.object({
    // format object-id: 1_096 (78.23%)
    id: z.string(),
    value: z.string(),
  }),
  // undefined: 174 (12.42%), defined 1_227 (87.58%)
  raw_value: z.string().optional(),
  value: z.union([
    // string samples: 1_319 (94.15%)
    z.string(),
    // object samples: 82 (5.85%)
    z.object({
      // null: 76 (92.68%)
      group_id: common.objectId.nullable(),
      // semver-y string
      id: z.string(),
      // semver-y string
      value: z.string(),
    }),
  ]),
  varies_by_app_group: z.literal(false),
});
